module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/core-js/modules/_fails.js
// module id = 37
// module chunks = 1